import React from "react";
import GenreDetail from "./GenreDetail/GenreDetail";

const GenreDetailPage = () => {
  return <GenreDetail />;
};

export default GenreDetailPage;
